<template src="./template.html"></template>

<style scoped lang="scss"> @import "style"; </style>

<script>
  import "exif-js";
  import "croppie";
  import {ValidationObserver, ValidationProvider} from "vee-validate";

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      close: {
        type: Function,
        default: () => {
        }
      },
      success: {
        type: Function,
        // eslint-disable-next-line no-unused-vars
        default: (file, source) => {
        }
      },
      file: {
        type: String,
        default: null
      }
    },
    name: 'Crop',
    created() {
    },
    watch: {
      show(val) {
        this.dialog = val;
        if (val) {
          this.dialog = true;
        }
      },
      file(content) {
        const self = this;
        // eslint-disable-next-line no-undef
        $("crop-area").attr("src", content);
        setTimeout(function () {
          // eslint-disable-next-line no-undef
          $("#crop-area").parent().html('<div id="crop-area"></div>');
          // eslint-disable-next-line no-undef
          self.cropper = $("#crop-area").croppie({
            enableExif: true,
            enableResize: false,
            enforceBoundary: true,
            viewport: {
              width: 250,
              height: 250,
              type: "circle"
            },
            boundary: {
              width: 280,
              height: 350
            }
          });

          self.cropper.croppie("bind", {
            url: content
          });
        }, 500);
      }
    },
    computed: {},
    data() {
      return {
        dialog: false,
        source: "",
        cropper: null
      }
    },
    methods: {
      onConfirm() {
        const self = this;
        // eslint-disable-next-line no-undef
        $("#crop-area").croppie('result', {
          type: 'blob',
          size: 'original'
        })
        .then(function(blob) {
          self.success(blob);
        });
      },
      onClose() {
        this.close();
      },
    },
    components: {
      ValidationProvider,
      ValidationObserver,
    },
  }
  ;
</script>